import * as $ from 'jquery';
import 'bootstrap';

export class expandableImgText {
	$expandBtn: any = $('.expand-btn');

	toggleContainer(): void {
		let _self = this;

		$.fn.rotate = function(delta:any) {
			 let degrees = $(this).data().rotation || 0;
			 degrees += delta;
			 $(this).data().rotation = degrees;
			 $(this).css({'transform' : 'rotate('+ degrees +'deg)'});
		};

		$('.expand-btn').click(function() {
				$(this).find('.fa').rotate(180);
		});
	}
}

let scope:Element = document.querySelector('.expand-btn');
if (scope){
	try {
		let expandableimgtext = new expandableImgText();
				expandableimgtext.toggleContainer();
	} catch(e) {console.error(e);}
}
